import { t } from '../../i18n.js';
import {showValidationErrors} from "../../utils/formHelpers";

export default function bookingSms({$, api, state, data, routes, emit, sharedState, onNext, onComplete, onSaveState}) {

    let autoSubmit = true;
    let resendTimeoutId = null;

    function render() {
        const $el = $(`
        <div class="booking-sms-row active" data-auth-step='booking-sms'>
            <button class="login-close-button auth-back-btn" data-step="booking-phone">&times;</button>
            <h3>${t('confirmPhoneTitle')}</h3>
            <p>${t('confirmPhoneSubTitle')}</p>
            <form class="booking-sms-form">
                <div class="form-row">
                    <label>${t('verification_code')}</label>
                    <div class="sms-code-container" id="smsCodeWrapper">
                        <input autocomplete="off" type="text" name="digits[]" class="sms-digit" pattern="[0-9]*" inputmode="numeric" maxlength="1" />
                        <input autocomplete="off" type="text" name="digits[]" class="sms-digit" pattern="[0-9]*" inputmode="numeric" maxlength="1" />
                        <input autocomplete="off" type="text" name="digits[]" class="sms-digit" pattern="[0-9]*" inputmode="numeric" maxlength="1" />
                        <input autocomplete="off" type="text" name="digits[]" class="sms-digit" pattern="[0-9]*" inputmode="numeric" maxlength="1" />
                        <input autocomplete="off" type="text" name="digits[]" class="sms-digit" pattern="[0-9]*" inputmode="numeric" maxlength="1" />
                        <input type="hidden" name="sms-code-value" value="" id="bookingSMS" />
                    </div>
                    <p class="field-error field-sms-error" style="display:none;">${t('incorrect_code')}</p>
                    <p class="hidden-input-value"></p>
                </div>
                <div class="form-actions">
                    <button type="submit">${t('submit_code')}</button>
                    <span id="resendSMS">${t('resend_code')}</span>
                </div>
            </form>
        </div>
        `);

        $el.find('#smsCodeWrapper').letteringInput({
            inputClass: 'sms-digit',
            hiddenInputWrapperID: 'smsCodeWrapper',
            hiddenInputName: 'sms-code-value',
            forbiddenKeyCodes: [],
            onLetterKeyup: function ($item, event) {
                console.log($item, event);
            },
            onSet: function ($e, event, value) {
                console.log("$e", $e);
                console.log("event", event);
                console.log("value", value);
                let val = $('input[name="sms-code-value"]', '#smsCodeWrapper').val();
                console.log("val:", val )
                $('.hidden-input-value').text(val);
                $el.find('.field-sms-error').hide();

                if (val && val.length > 0) {
                    const inputs = $el.find('input.sms-digit');
                    if (val && val.length === inputs.length) {
                        $el.find('.form-actions button').removeClass('disabled');
                        // auto submit - do this once.
                        if(autoSubmit) {
                            autoSubmit = false;
                            validateCode($el);
                        }
                    } else {
                        $el.find('.form-actions button').addClass('disabled');
                    }
                }
            },
        });

        $el.find('.booking-sms-form').on('submit', e => {
            e.preventDefault();
            validateCode($el);
        });

        const resendBtn = $el.find('#resendSMS');

        resendBtn.on('click', e => {
            e.preventDefault();
            resendBtn.attr('disabled', 'disabled');
            const phone = sharedState.phone;
            if(sharedState.noAccount) {
                if(data.skipValidate) {
                    onComplete();
                } else {
                    getCode($el, routes.generateCode, { phone });
                }
            } else {
                let email = sharedState.email;
                getCode($el, routes.validatePhone, { phone, email, resend: 'yes' });
            }
        }).hide();

        hideAndShowResendBtn(resendBtn);

        return $el;
    }

    function hideAndShowResendBtn(resendBtn) {
        // Clear any existing timeout
        if (resendTimeoutId !== null) {
            clearTimeout(resendTimeoutId);
            resendTimeoutId = null;
        }

        // Hide the button immediately
        resendBtn.hide();

        // Set a new timeout to show it in 60 seconds
        resendTimeoutId = setTimeout(() => {
            resendBtn.show();
            resendTimeoutId = null;
        }, 60000);
    }

    function validateCode($el) {
        const value = $el.find('input[name="sms-code-value"]').val();
        if (value && value.length > 0) {
            const inputs = $el.find('input.sms-digit');
            if (value && value.length === inputs.length) {
                data = {
                    code: value,
                    phone: sharedState.phone,
                };
                if(sharedState?.email) {
                    data.email = sharedState.email;
                }
                api.get(routes.validateCode, {
                    data: data,
                    success: (data) => {
                        onComplete(data);
                    },
                    error: (err) => {
                        console.warn(err);
                        $el.find('.field-sms-error').show();
                        // TODO: show error
                    }
                });
            }
        }
    }

    function getCode($el, url, param) {
        const resendBtn = $el.find('#resendSMS');

        api.post(url, {
            data: param,
            success: (data) => {
                resendBtn.removeAttr('disabled');
                hideAndShowResendBtn(resendBtn);
            },
            error: (err) => {
                console.warn('Failed:', err);
                showValidationErrors($el, err.data.errors || {});
                resendBtn.removeAttr('disabled');
            }
        })
    }

    return {render};
}